'use strict';

import PropTypes from 'prop-types';
import { Component } from 'react';
import Modal from 'react-modal';

import PlanEditor from '@components/Plans/Editor.react';

import './CustomizerModal.scss';

export default class CustomizerModal extends Component {
    static propTypes = {
        uuid: PropTypes.string,
        closeModal: PropTypes.func,
        patient: PropTypes.object,
        preferences: PropTypes.object,
        recommendations: PropTypes.object,
        showPdfPrint: PropTypes.bool,
        onSavePlan: PropTypes.func,
        profile: PropTypes.object,
    };

    static contextTypes = {
        router: PropTypes.object,
        location: PropTypes.object,
        confirm: PropTypes.func,
        isPro: PropTypes.bool,
        isMobile: PropTypes.bool,
        isCordova: PropTypes.bool,
        showLoginForm: PropTypes.func,
        replaceMealPlan: PropTypes.func,
        showUpgradeForm: PropTypes.func,
    };

    state = {
        hasUnsavedChanges: false,
    };

    setHasUnsavedChanges = (hasChanges) => {
        this.setState({ hasUnsavedChanges: hasChanges });
    };

    handleBackClick = () => {
        const { closeModal } = this.props;
        const { hasUnsavedChanges } = this.state;

        if (hasUnsavedChanges) {
            this.context.confirm(
                <p>You have unsaved changes to your meal plan. Are you sure you want to leave without saving?</p>,
                () => {
                    // User confirmed - close the modal
                    closeModal();
                },
                () => {
                    // User cancelled - do nothing
                },
                {
                    acceptText: 'Leave Without Saving',
                    rejectText: 'Cancel',
                }
            );
        } else {
            closeModal();
        }
    };

    render() {

        const { uuid, closeModal, patient, showAddToPlanner, showPdfPrint, editableParticipants, onSavePlan, profile, altPatient } = this.props;
        const { router, location, confirm, isPro, isMobile, isCordova, showLoginForm, replaceMealPlan, showUpgradeForm } = this.context;

        return (
            <Modal isOpen={true}
                onRequestClose={this.handleBackClick}
                closeModal={closeModal}
                className="el-modal el-modal4 meal-plan-editor-modal"
                overlayClassName="el-modal-overlay4"
                contentLabel="Meal Plan"
                closeTimeoutMS={250}>

                <div className="el-modal-container el-modal4-container">
                    <header data-has-controls={false}>
                        <button className="el-modal-back-btn" onClick={this.handleBackClick}>
                            <span>Back</span>
                        </button>

                        <h2>Meal Plan</h2>
                    </header>

                    <div className="el-modal-body-container el-modal4-body-container el-fonts">
                        <PlanEditor uuid={uuid}
                            location={location}
                            patient={patient}
                            profile={profile}
                            altPatient={altPatient}
                            showAddToPlanner={showAddToPlanner}
                            showPdfPrint={showPdfPrint}
                            editableParticipants={editableParticipants}
                            closeModal={closeModal}
                            onSavePlan={onSavePlan}
                            onPlanUuidChanged={(newUuid, oldUuid) => {
                                // Create plan objects for replaceMealPlan
                                const oldPlan = { uuid: oldUuid };
                                const newPlan = { uuid: newUuid };
                                replaceMealPlan(oldPlan, newPlan);
                            }}
                            onUnsavedChangesChanged={this.setHasUnsavedChanges}
                            showConsumerFavoriteButton={true}
                            router={router}
                            confirm={confirm}
                            isPro={isPro}
                            isMobile={isMobile}
                            isCordova={isCordova}
                            showLoginForm={showLoginForm}
                            showUpgradeForm={showUpgradeForm} />
                    </div>
                </div>
            </Modal>
        );
    }
}
